export default "__VITE_ASSET__DLZqPj$O__"